<template>
  <div class="form">
    <!--begin::Content header-->

    <!--end::Content header-->
    <!--begin::Form-->
    <div class="instructions">
      <div class="instructions-content">
        <h3>Bienvenido al nuevo portal <img :src="images.logo" /></h3>
        <p>
          Aquí podrás encontrar toda la información de tu proceso de compra, el
          estado de tus solicitudes y mucho más.
        </p>
        <div class="steps">
          <ul>
            <li>
              En <strong>bricsa.cl</strong> ingresa a la sección<img
                :src="images.logo"
              />
            </li>
            <li>
              Accede con tu RUT e ingresa tu clave inicial que son los últimos 4
              dígitos de tu RUT (sin considerar el dígito verificador). Ej:
              <strong> 1111<span>1</span><span>111</span>-1</strong>
            </li>
            <li>Te sugerimos actualizar tu clave.</li>
            <li>
              <strong>Ya estás listo para navegar por</strong
              ><img :src="images.logo" />
            </li>
          </ul>
        </div>
        <p>
          (El acceso se habilita una vez que firmas tu promesa de compra venta)
        </p>
      </div>
    </div>
    <b-form
      class="form-signin d-flex align-items-stretch flex-column"
      @submit.stop.prevent="onSubmit"
    >
      <div class="text-center mb-2">
        <h3 class="mb-0">Iniciar Sesión</h3>
        <span>Ingresa tu Rut y clave</span>
      </div>

      <div
        role="alert"
        v-show="errors.length > 0"
        v-bind:class="{ show: errors.length }"
        class="alert alert-danger"
      >
        <div class="alert-text" v-for="(error, i) in errors" :key="i">
          {{ error }}
        </div>
      </div> 

      <div class="form-label-group">
        <label for="inputRut">Rut</label>
        <b-form-input
          class="form-control"
          id="example-input-1"
          name="example-input-1"
          placeholder="11111111-1"
          v-model="$v.form.rut.$model"
          :state="validateState('rut')"
          aria-describedby="input-1-live-feedback"
          autofocus
        ></b-form-input>
        <b-form-invalid-feedback id="input-1-live-feedback">
          Rut es requerido y debe ser valido.
        </b-form-invalid-feedback>
      </div>

      <div class="form-label-group">
        <label for="inputPassword">Contraseña</label>
        <b-form-input
          class="form-control"
          type="password"
          id="example-input-2"
          name="example-input-2"
           placeholder="contraseña"
          v-model="$v.form.password.$model"
          :state="validateState('password')"
          aria-describedby="input-2-live-feedback"
        ></b-form-input>

        <b-form-invalid-feedback id="input-2-live-feedback">
          Contraseña es requerida.
        </b-form-invalid-feedback>
      </div>

      <!--begin::Action-->
      <button ref="kt_login_signin_submit" class="align-self-center">
        Ingresar
      </button>

      <p class="mt-3 mb-3 text-muted text-center">
        <a
          href="#"
          v-on:click="$router.push('recovery')"
          class="recovery-btn text-dark-60 text-hover-primary my-3 mr-2"
          id="kt_login_forgot"
        >
          ¿Has olvidado tu contraseña?
        </a>
      </p>

      <!--end::Action-->
    </b-form>
    <!--end::Form-->
  </div>
</template>

<style lang="scss" scoped>
.instructions {
  width: 100%;
  padding: 20px;
  .instructions-content {
    display: grid;
    row-gap: 10px;
    h3 {
      font-size: 20px;
      font-weight: bold;
      color: var(--bricsa-grey);
      img {
        width: 150px;
        @media screen and (max-width: 1024px) {
          width: 80px;
        }
      }
    }
    .steps {
      padding: 20px 30px;
      background: #eaeaea;
      ul {
        list-style-type: disc;
        display: grid;
        row-gap: 10px;
        li {
          span {
            color: var(--bricsa-red);
          }
          img {
            margin-left: 5px;
            width: 100px;
          }
        }
      }
    }
  }
}
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
.recovery-btn {
  color: #252525;
  transition: 200ms;
  &:hover {
    color: #0a2188;
  }
}
</style>

<script>
import { mapState } from "vuex";
import { LOGIN, LOGOUT } from "@/core/services/store/auth.module";
import { rutEsValido } from "@/core/validators/rut.js";
import JwtService from "@/core/services/jwt.service";
import RoleService from "@/core/services/role.service";
import { validationMixin } from "vuelidate";
import { minLength, required } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  name: "login",
  data() {
    return {
      // Remove this dummy login info
      form: {
        rut: "",
        password: "",
      },
      images: {
        logo: process.env.BASE_URL + "./media/logo.png",
      },
    };
  },
  mounted() {
    JwtService.destroyToken();
    this.validateToken();
  },
  validations: {
    form: {
      rut: {
        required,
        rutEsValido,
      },
      password: {
        required,
        minLength: minLength(3),
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        rut: null,
        password: null,
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    validateToken(){
      const token = this.$route.params.token;
      if(typeof token!='undefined'){
        JwtService.saveToken(token);
        RoleService.saveRole("Cliente");
        this.$router.push({ name: "dashboard" });
      }

    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      const rut = this.$v.form.rut.$model;
      const password = this.$v.form.password.$model;

      // clear existing errors
      this.$store.dispatch(LOGOUT);

      // set spinner to submit button
      const submitButton = this.$refs["kt_login_signin_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      // dummy delay
      setTimeout(() => {
        // send login request
        this.$store
          .dispatch(LOGIN, { rut, password })
          // go to which page after successfully login
          .then((response) => {
            submitButton.classList.remove(
              "spinner",
              "spinner-light",
              "spinner-right"
            );
            if (response.debeCambiarClave) {
              this.$router.push({
                name: "changePassword",
                params: { token: response.tokenUsuario },
              });
            } else {
              this.$router.push({ name: "dashboard" });
            }
          })
          .catch(() => {});
        setTimeout(() => {
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        }, 2000);
      }, 500);
    },
  },
  computed: {
    ...mapState({
      errors: (state) => state.auth.errors,
    }),
  },
};
</script>
